<script>
    // -- VARIABLES
    
    /** @type {{layoutType?: string, showOnlyMediaAndText?: boolean}} */
    let { layoutType = $bindable('text-and-media'), showOnlyMediaAndText = false } = $props();

    let allLayoutArray = [
        {
            name: 'Text and media',
            slug: 'text-and-media',
            media: '/image/icon/text-midia.svg'
        },
        {
            name: 'media and Text',
            slug: 'media-and-text',
            media: '/image/icon/midia-text.svg'
        },
        {
            name: 'Text and media vertical',
            slug: 'text-and-media-vertical',
            media: '/image/icon/text-midia-vertical.svg'
        },
        {
            name: 'media and Text vertical',
            slug: 'media-and-text-vertical',
            media: '/image/icon/midia-text-vertical.svg'
        },
        {
            name: 'media',
            slug: 'media',
            media: '/image/icon/midia.svg'
        },
        {
            name: 'Text',
            slug: 'text',
            media: '/image/icon/text.svg'
        },
        {
            name: 'List',
            slug: 'list',
            media: '/image/icon/list.svg'
        },
        {
            name: 'Card Group',
            slug: 'card-group',
            media: '/image/icon/list.svg'
        },
    ];

    let layoutImageAndTitleArray = [
        {
            name: 'Text and media',
            slug: 'text-and-media',
            media: '/image/icon/text-midia.svg'
        },
        {
            name: 'media and Text',
            slug: 'media-and-text',
            media: '/image/icon/midia-text.svg'
        },
        {
            name: 'Text and media vertical',
            slug: 'text-and-media-vertical',
            media: '/image/icon/text-midia-vertical.svg'
        },
        {
            name: 'media and Text vertical',
            slug: 'media-and-text-vertical',
            media: '/image/icon/midia-text-vertical.svg'
        }
    ];

    let layoutTypeArray = showOnlyMediaAndText 
                            ? layoutImageAndTitleArray 
                            : allLayoutArray;

    // -- FUNCTIONS

    function setLayout(
        layoutSlug 
        )
    {
        layoutType = layoutSlug;
    }
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';
    @import '../../../element.styl';

    // -- CLASSES

    .layout-select-container
    {
        max-width: 100%;

        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
        gap: .5rem;
    }

    .layout-container
    {
        min-width: 10rem;
        padding: 1rem;
        border-radius: 4px;
        border: 1px solid darkGrayColor; 

        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;

        background-color: darkGrayColor;

        cursor: pointer;

        transition: background-color .3s ease-in-out, border .3s ease-in-out;
    }

    .layout-container:hover
    {
        background-color: #3d3d3d;
    }

    .is-active
    {
        border: 1px solid lightGoldColor;   
    }

    .layout-image
    {
        max-width: 100%;

        transition: all 0.3s ease-in-out;
    }
    
    .layout-name
    {
        color: lightGreyColor;
    }
</style>

<div class="layout-select-container">
    {#each layoutTypeArray as layout }
        <button 
            type="button"
            class="layout-container"
            class:is-active={ layout.slug === layoutType }
            onclick={() => setLayout( layout.slug )}
        >
            <img 
                class="layout-image"
                src={ layout.media } 
                alt={ layout.name } 
            />
            
            <p class="layout-name" >
                { layout.name }
            </p>
        </button>
    {/each}
</div>